<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>
    <!--TOPIC DAN PEROIDE BERITA-->
    <v-layout row wrap class="ma-0 pa-0">
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          label="Topic"
          dense
          outlined
          rounded
          @change="parameter_proses_topic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topickeywordsentiment"
          v-model="selectedTopic2"
          class="elevation-0 shadow-0"
          label="Keyword"
          dense
          outlined
          rounded
          @change="parameter_proses_keyword"
        ></v-select>
      </v-col>

      <!--Data Source-->
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="itemsDataSource"
          item-text="NAME_SOCIAL_MEDIA"
          item-value="ID"
          v-model="selectedDataSource"
          class="elevation-0 shadow-0"
          label="Data Source"
          dense
          outlined
          rounded
          @change="parameter_proses_topic()"
        ></v-select>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          label="Periode Berita"
          dense
          outlined
          rounded
          @change="parameter_proses_periode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      width="120"
                      color="#0471A5"
                    >
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row justify="space-around" class="ma-4">
                      <v-date-picker
                        v-model="date1"
                        dense
                        :show-current="false"
                        color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="date2"
                        class="ml-8"
                        :show-current="false"
                        color="#0471A5"
                        header-color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="menu = false, parameter_proses_custom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <!-- <v-col > -->
        <v-card v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'" class="d-flex ma-0 pa-0" cols="12" sm="2" height="37" outlined style="border-radius: 30px;">
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2">
              {{ showDate1[1] + " " + showDate1[0] + " " + showDate1[2] }} - {{ showDate2[1] + " " + showDate2[0] + " " + showDate2[2] }}
            </span>
          </v-card-text>
        </v-card>
      <!-- </v-col> -->


      <!-- Button Hit API -->
      <v-col class="d-flex ma-0 pa-0" sm="1">
        <v-btn
          class="ml-4"
          color="#439EDF"
          dense
          dark
          rounded
          @click="parameter_proses_periode(), loadDiscoverPerson()"
        >
          <v-icon class="ml-2">mdi-magnify</v-icon>
        </v-btn>
      </v-col>
      <!-- End Button Hit API -->
    </v-layout>

    <v-layout row wrap>
      <v-flex lg8>
        <v-card color="#F4F7FA" class="mb-6 rounded-lg" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card height="430px" class="mx-4 mb-6 rounded-lg pa-4" flat>
                <div>
                  <apexcharts
                    :options="sentimentanalysis"
                    :series="seriessentiment"
                    class="mt-4 py-4"
                    type="area"
                    width="100%"
                    height="360px"
                  ></apexcharts>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg4>
        <v-card color="#F4F7FA" class="mb-6 rounded-lg" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card height="430px" class="mx-4 mb-6 rounded-lg pa-4" flat>
                <div>
                  <Toppersonbubblepinnedentity
                    ref="topPersonComponent"
                    :selectedTopic2="selectedTopic2"
                    :selectedTopic="selectedTopic"
                    :selectedPeriode="selectedPeriode"
                    :statusFilter="statusFilter"
                    :isClickBubleOrg="isClickBubleOrg"
                    :isClickWord="isClickWord"
                    :resetcolorClicked="resetcolorClicked"
                    :updateSocket="updateSocket"
                  ></Toppersonbubblepinnedentity>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-2">
      <v-flex lg12>
        <v-card  class="mx-4 rounded-lg pa-4 overflow-card" flat>
          <v-tabs color="#0471A5">
            <v-tab style="position: -webkit-sticky;position: sticky;top: 0;z-index: 1000;" v-for="item in listDataContent" :key="item.organization_id" @click="page = 1, loadDiscoverPersonContent(item)">
              {{ item.organization }}
              <v-chip small class="ma-2" color="#0471A5" text-color="white">
                {{ item.total_content }} 
              </v-chip>
            </v-tab>
          
            <v-tab-item v-for="item in listDataContent" :key="item.person_id">
              <v-flex v-for="item in listContent" :key="item.id" lg12>
                <v-card
                  :href="item.url"
                  target="_blank"
                  flat
                  :class="{'rounded-lg custom-card': index === 0, 'mt-2 rounded-lg custom-card': index !== 0}"
                  style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                            {{ item.title }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                            {{ item.content }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                            <div class="d-flex align-center">
                              <v-avatar v-if="sourceCollection == 'NEWS'" class="color-avatar4" size="26">
                                <v-icon class="white--text" size="22">mdi-web</v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'TWITTER'" class="color-avatar6" size="26">
                                <v-icon class="white--text" size="22">fa-brands fa-x-twitter</v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'YOUTUBE'" class="color-avatar2" size="26">
                                <v-icon class="white--text" size="22">mdi-youtube</v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'TIK TOK'" class="color-avatar6" size="26">
                                <v-icon class="white--text" size="22">fa-brands fa-tiktok</v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'INSTAGRAM'" class="color-avatar7" size="26">
                                <v-icon class="white--text" size="22">mdi-instagram</v-icon>
                              </v-avatar>
                              <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                {{ item.url }}
                              </span>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-tab-item>
          </v-tabs>
        </v-card>


        <!-- v-for="(item, i) in listDataContent" :key="item.organization_id" -->
        <div  class="text-center">
          <!-- v-if="item.organization_id == selectedContent && item.organization == selectedOrganization" -->
          <v-pagination
            class="mt-2 my-2"
            v-model="page"
            :length="pagelength"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChange"
          ></v-pagination>
        </div>




        
      </v-flex>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="#0471A5"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import VueApexCharts from 'vue-apexcharts';
import { decryptionData } from '@/components/utils/utils.js';
import Notification from '@/components/Notification';
import Toppersonbubblepinnedentity from '@/components/Toppersonbubblepinnedentity';
import { mapGetters } from 'vuex';

export default {
  components: {
    Toppersonbubblepinnedentity,
    apexcharts: VueApexCharts,
    Notification: Notification
  },
  data: function() {
    return {
      sourceCollection: "",
      // itemsDataSource: [
      //   {
      //     text: "News",
      //     value: 0,
      //   },
      //   {
      //     text: "Twitter",
      //     value: 1,
      //   },
      //   {
      //     text: "Youtube",
      //     value: 2,
      //   },
      // ],
      selectedDataSource: 0,
      listOrganization: "",
      listDataChart: "",
      listDataContent: "",
      selectedContent: "",
      selectedOrganization: "",
      listContent: "",
      menu: false,
      dialog: false,
      click: "",
      selectedTopic: "",
      selectedTopic2: "",
      selectedPeriode: "Last 7 Days",
      topicsentiment: [],
      topickeywordsentiment: [],
      collection_parm: [],
      periodeberita: [
        "Today",
        "Yesterday",
        "Last 7 Days",
        "Previous Week",
        "Last 30 Days",
        "Previous Month",
      ],
      showDate1: "",
      showDate2: "",
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),



      pageplay: 10,
      page: 1,
      pagelength: "",


      statusFilter: "",
      isClickBubleOrg: "",
      isClickWord: "",
      resetcolorClicked: false,
      updateSocket: "",
      alert: false,
      colorAlert: "",
      message: "",
      Settanggal: [],
      startDate: [],
      endDate: [],
      sentimentanalysis: {
        chart: {
          id: 'Memory Usage',
          background: 'transparent'
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
          x: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#45AF5B', '#FF1752', '#008FFB', '#FFB000', '#814AD6', '#000'],
        xaxis: {
          categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriessentiment: []
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
  mounted() {
    this.loadTopic();
  },
  methods: {
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    async loadTopic() {
      this.dialog = true;
      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        // this.posts = response.data;
        // const data = response.data;
        const data_dec = decryptionData(response.data.token);
        this.posts = data_dec.keyword;
        const data = data_dec.keyword;
         
        // alert(data.length);
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }
        this.$store.commit("addTopicKeyword", {
          //send parameter store
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  // this.selectedTopic2 = (data[i].KEYWORD[x].KEYWORD);
                  this.selectedTopic2 = all;
                } else {
                  this.selectedTopic2 = this.$store.topic_glob2;
                }
              }
              // alert(data[i].KEYWORD[x].KEYWORD);
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
          }
        }

        // topickeywordsentiment
        var date_start = this.date1;
        var date_end = this.date2;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          const date_awal = new Date();
          const date = new Date();
          date.setDate(date.getDate() + 0);
          const datenow = date.toISOString().substr(0, 10);
          if (this.selectedPeriode == "Today") {
            this.click = "Today";
            date_start = datenow;
            date_end = datenow;
          }
          if (this.selectedPeriode == "Yesterday") {
            this.click = "Yesterday";
            date_awal.setDate(date_awal.getDate() - 1);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = date_c;
          }
          if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
            this.click = "Last 7 Days";
            date_awal.setDate(date_awal.getDate() - 7);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = datenow;
          }
          if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
            this.click = "Last 30 Days";
            date_awal.setDate(date_awal.getDate() - 30);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = datenow;
          }
        }
        // coolection parameter 
        if (this.$store.collectionstore == "" || this.$store.collectionstore == undefined) {
            this.$store.commit("collectionactive", {
              collection_send: data_dec.collection,
              collection_select_send:  data_dec.collection[0].ID,
            });
            this.itemsDataSource =data_dec.collection;
            this.selectedDataSource =  data_dec.collection[0].ID ;
        }else{
            this.itemsDataSource =data_dec.collection;
            this.selectedDataSource =this.$store.collectionSelectstore;
        }
        // end coolection parameter 

        
        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          // alert('aaa');
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedTopic2,
            data_source_glob: this.selectedDataSource,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
          });
          
          
        } else {
          this.selectedTopic2 = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.date1 = this.$store.date_start_glob;
          this.date2 = this.$store.date_end_glob;
        }

        // console.log(this.$store.date_start_glob)
        if (data.length > 0) {
          this.loadDiscoverPerson();
        }
        if (this.selectedPeriode == "Custom") {
          this.showCustomDate();
        }

        setTimeout(() => {
          this.dialog = false;
        }, 3000);
      })
      .catch((e) => {
        if (!e.data_dec) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API Keyword Select refused to connect";
          this.colorAlert = "red";
        }
        this.errors = e.data_dec.data.msg;
        switch (e.data_dec.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },

    async parameter_proses_topic() {
      var date_start = this.date1;
      var date_end = this.date2;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        //sincron data topic sentiment
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              // this.selectedTopic2 = (this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedTopic2 = all;
              } else {
                this.selectedTopic2 = this.$store.topic_glob2;
              }
            }
            // alert(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD +' - '+ x);
            this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      // this.loadKontenBerita2()
    },
    async parameter_proses_keyword() {
      var date_start = this.date1;
      var date_end = this.date2;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      this.parameter_proses_periode();
    },
    async parameter_proses_periode() {
      var date_start = this.date1;
      var date_end = this.date2;
      const date_awal = new Date();
      const date = new Date();
      date.setDate(date.getDate() + 0);
      const datenow = date.toISOString().substr(0, 10);
      if (this.selectedPeriode == "Today") {
        this.click = "Today";
        date_start = datenow;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Yesterday") {
        this.click = "Yesterday";
        date_awal.setDate(date_awal.getDate() - 1);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = date_c;
      }
      if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
        this.click = "Last 7 Days";
        date_awal.setDate(date_awal.getDate() - 7);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
        this.click = "Last 30 Days";
        date_awal.setDate(date_awal.getDate() - 30);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      // this.loadKontenBerita2()
    },
    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";

      // alert(this.selectedPeriode);
      var date_start = this.date1;
      var date_end = this.date2;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      // this.loadKontenBerita2()
    },

    async loadDiscoverPerson() {
      // let source = this.$store.data_source_glob;
      // if(this.$store.data_source_glob == undefined){
      //   source = 0;
      // }
      let source = this.selectedDataSource;
      if(this.selectedDataSource == undefined){
        source = this.$store.data_source_glob;
      }
      this.dialog = true;
      axios.post("/pinned-history-entity",
        {
          "start_date": this.$store.date_start_glob,
          "end_date": this.$store.date_end_glob,
          "topic_id": this.$store.topic_glob,
          "keyword": this.$store.topic_glob2,
          "source": source,
          "startpage": 0,
          "pageShow": this.pageplay
        },
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        
        const data_respon = decryptionData(response.data.token);

        this.$store.commit("dataBubble", {bubble_data: data_respon});
        this.$refs.topPersonComponent.generatebubble();
        if (data_respon.data_chart.length != 0) {
          this.listOrganization = data_respon.data_bubble;
          this.listDataChart = data_respon.data_chart;
          this.listDataContent = data_respon.list_organization.slice(0, 6);
          // console.log(data_respon.list_organization);
          this.selectedContent = this.listDataContent[0].organization_id;
          this.selectedOrganization = this.listDataContent[0].organization;

          this.Settanggal = [];
          for (let i = 0; i < this.listDataChart.length; i++) {
            for (let a = 0; a < this.listDataChart[i].chart_date.length; a++) {
              this.Settanggal.push(this.listDataChart[i].chart_date[a].period);
            }
          }

          const Settanggal = [...new Set(this.Settanggal)];

          this.Settanggal = Settanggal;

          let parsedDates = this.Settanggal.map(date => new Date(date));

          parsedDates.sort((a, b) => a - b);

          this.startDate = parsedDates[0].toISOString().split('T')[0];
          this.endDate = parsedDates[parsedDates.length - 1].toISOString().split('T')[0];

          this.seriessentiment = [];

          for (let i = 0; i < this.listDataChart.length; i++) {
            this.listDataChart[i].chart_date.sort((a, b) => {
              return new Date(a.period) - new Date(b.period);
            });

            this.seriessentiment.push({
              name: this.listDataChart[i].organization,
              data: [],
            });

            for (let a = 0; a < this.listDataChart[i].chart_date.length; a++) {
              const period = this.listDataChart[i].chart_date[a].period;
              const jumlah = this.listDataChart[i].chart_date[a].jumlah;

              const startDate = new Date(this.startDate);
              const endDate = new Date(this.endDate);
              const currentDate = new Date(period);

              if (currentDate >= startDate && currentDate <= endDate) {
                this.seriessentiment[i].data.push({
                  x: period,
                  y: jumlah,
                });
              }
            }
          }

          for (let i = 0; i < this.seriessentiment.length; i++) {
            const existingDates = this.seriessentiment[i].data.map(d => d.x);
            for (let date of this.Settanggal) {
              if (!existingDates.includes(date)) {
                this.seriessentiment[i].data.push({ x: date, y: 0 });
              }
            }
            this.seriessentiment[i].data.sort((a, b) => new Date(a.x) - new Date(b.x));
          }
        }

        this.seriessentiment = this.seriessentiment.slice(0, 6);

        if (data_respon.data_chart.length == 0) {
          this.seriessentiment = [];
          this.listDataChart = "";
          this.listDataContent = "";
        }
          // this.loadDiscoverPersonContent(this.listDataContent[0]);


        window.dispatchEvent(new Event("resize"));
        setTimeout(() => {
          this.dialog = false;
        }, 3000);
      })
      .catch((e) => {
        if (!e.response) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API pinned-history-entity refused to connect";
          this.colorAlert = "red";
        }
        this.errors = e.data_respon.msg;
        switch (e.response.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },
    async loadDiscoverPersonContent(item) {
      this.selectedContent = item.organization_id;
      this.selectedOrganization = item.organization;
      this.dialog = true;
      axios.post("/pinned-history-entity-content",
        {
          "start_date": this.$store.date_start_glob,
          "end_date": this.$store.date_end_glob,
          "topic_id": this.$store.topic_glob,
          "keyword": this.$store.topic_glob2,
          "organization_id": this.selectedContent,
          "source": this.$store.data_source_glob,
          "startpage": 0,
          "pageShow": this.pageplay
        },
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        
        const data_respon = decryptionData(response.data.token);
        this.listContent = data_respon.data_content.content;
        this.sourceCollection = data_respon.data_content.sourceCollection;
        window.dispatchEvent(new Event("resize"));
        // console.log(data_respon.data_content.content);

        
        this.pagelength = data_respon.data_content.pageleght;

        setTimeout(() => {
          this.dialog = false;
        }, 3000);
      })
      .catch((e) => {
        if (!e.response) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API pinned-history-entity-content refused to connect";
          this.colorAlert = "red";
        }
        this.errors = e.data_respon.msg;
        switch (e.response.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },
    async handlePageChange(value) {
      this.dialog = true;
      const startPage = this.pageplay * (value - 1);
      try {
        const data1 = await axios
          .post("/pinned-history-entity-content",
            {
              "start_date": this.$store.date_start_glob,
              "end_date": this.$store.date_end_glob,
              "topic_id": this.$store.topic_glob,
              "keyword": this.$store.topic_glob2,
              "organization_id": this.selectedContent,
              "source": this.$store.data_source_glob,
              "startpage": startPage,
              "pageShow": this.pageplay
            },
            { headers: { 'auth-token': localStorage.getItem('token_app') } },
            { dataType: 'json' }
          )
          const data_respon = decryptionData(data1.data.token);

          this.listContent = data_respon.data_content.content;
          this.sourceCollection = data_respon.data.data_content.sourceCollection;
          this.pagelength = data_respon.data_content.pageleght;
          setTimeout(() => {
            this.dialog = false;
          }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    }
  }
}
</script>

<style> /*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}
.btn-ok {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar3 {
  background-image:
  linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
}
.v-avatar.color-avatar6 {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}
.v-avatar.color-avatar7 {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}

.my-responsive-card {
  /* height: auto; */
  max-height: 100%; /* Ensures it doesn't overflow */
  height: 500px; /* Set the desired height */
  overflow-y: auto;
}
</style>
